const template = document.createElement('template');
template.innerHTML = `
<style>
    :host {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 95%; /* Responsive width */
        max-width: 1140px; /* Fits approx 3 octaves comfortably */
        background: rgba(0, 0, 0, 0.85);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        box-shadow: 0 8px 32px rgba(0,0,0,0.6);
        user-select: none;
        z-index: 100;
        transition: max-height 0.3s cubic-bezier(0.4, 0.0, 0.2, 1), transform 0.1s linear, opacity 0.2s;
        overflow: hidden;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 15px;
        background: rgba(255, 255, 255, 0.08);
        cursor: grab;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        height: 40px;
    }

    .header:active {
        cursor: grabbing;
    }

    .title-group {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .title {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.9rem;
        font-weight: bold;
        color: #ddd;
        letter-spacing: 1px;
    }

    .controls {
        display: flex;
        align-items: center;
        gap: 5px;
        background: rgba(0,0,0,0.3);
        border-radius: 4px;
        padding: 2px;
        border: 1px solid rgba(255,255,255,0.1);
    }
    
    .range-toggle {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.65rem;
        background: transparent;
        border: 1px solid rgba(255,255,255,0.2);
        color: #aaa;
        padding: 2px 5px;
        border-radius: 3px;
        cursor: pointer;
        margin-right: 5px;
    }
    
    .range-toggle:hover {
        color: #fff;
        border-color: rgba(255,255,255,0.5);
    }

    .vel-control {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-left: 10px;
        margin-right: 5px;
    }

    .vel-label {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.7rem;
        color: #aaa;
        font-weight: bold;
    }

    input[type=range].vel-slider {
        -webkit-appearance: none;
        width: 80px;
        height: 4px;
        background: rgba(255,255,255,0.2);
        border-radius: 2px;
        outline: none;
    }

    input[type=range].vel-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 12px;
        height: 12px;
        background: var(--primary-color, #00ffcc);
        border-radius: 50%;
        cursor: pointer;
        margin-top: -4px;
    }

    .oct-btn {
        background: rgba(255,255,255,0.1);
        border: none;
        color: #eee;
        width: 24px;
        height: 24px;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        transition: background 0.2s;
        position: relative;
    }

    .oct-btn:hover {
        background: rgba(255,255,255,0.3);
    }

    .oct-btn:active {
        background: var(--primary-color, #00ffcc);
        color: #000;
    }

    .oct-display {
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.75rem;
        color: var(--primary-color, #00ffcc);
        min-width: 60px;
        text-align: center;
        font-weight: bold;
    }

    .fold-btn {
        background: transparent;
        border: none;
        color: #aaa;
        cursor: pointer;
        padding: 5px;
        display: flex;
        transition: transform 0.3s;
    }

    .fold-btn:hover {
        color: #fff;
    }

    :host(.folded) .fold-btn {
        transform: rotate(-90deg);
    }

    .keys-container {
        display: flex;
        height: 160px;
        padding: 5px;
        gap: 2px;
        transition: opacity 0.2s;
        position: relative;
    }

    :host(.folded) .keys-container {
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
    }

    .keyboard-octave {
        display: flex;
        position: relative;
        flex: 1;
        gap: 1px;
    }
    
    .white-key {
        flex: 1;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 0 0 4px 4px;
        position: relative;
        cursor: pointer;
        box-shadow: inset 0 -2px 5px rgba(0,0,0,0.2);
        transition: background 0.05s;
    }
    
    .white-key:active, .white-key.active {
        background: var(--primary-color, #00ffcc);
        box-shadow: 0 0 15px var(--primary-color, #00ffcc);
        transform: translateY(1px);
    }

    .white-key .note-label {
        position: absolute;
        bottom: 5px;
        width: 100%;
        text-align: center;
        font-size: 0.6rem;
        color: rgba(0,0,0,0.5);
        pointer-events: none;
        font-weight: bold;
    }

    .black-key {
        position: absolute;
        top: 0;
        width: 12%; 
        height: 60%;
        background: linear-gradient(to bottom, #222, #000);
        border-radius: 0 0 3px 3px;
        z-index: 2;
        border: 1px solid #444;
        box-shadow: 2px 2px 5px rgba(0,0,0,0.5);
        cursor: pointer;
        transition: background 0.05s;
    }

    .black-key:active, .black-key.active {
        background: var(--primary-color, #00ffcc);
        box-shadow: 0 0 15px var(--primary-color, #00ffcc);
    }

    /* Positioning black keys (percent of octave width) */
    .bk-1 { left: 10%; } /* C# */
    .bk-2 { left: 26.5%; } /* D# */
    .bk-3 { left: 53%; } /* F# */
    .bk-4 { left: 69.5%; } /* G# */
    .bk-5 { left: 86%; } /* A# */

    @media (max-width: 600px) {
        .title { display: none; }
        .vel-control { display: none; } /* Hide velocity on small screens to save space */
        :host {
             width: 100%;
             max-width: 100%;
             border-radius: 12px 12px 0 0;
             left: 0;
             transform: none;
             bottom: 80px;
             border-left: none;
             border-right: none;
        }
    }

    .key-hint {
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.7);
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.85rem;
        font-weight: 900;
        color: #fff;
        background: rgba(0, 10, 10, 0.95);
        padding: 4px 8px;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        border: 1px solid var(--primary-color, #00ffcc);
        box-shadow: 0 0 15px rgba(0, 255, 204, 0.5), inset 0 0 8px rgba(0, 255, 204, 0.2);
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 1rem;
        text-shadow: 0 0 5px #fff;
        border-radius: 2px;
    }

    /* HUD Corner Brackets */
    .key-hint::before, .key-hint::after {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        border: 2px solid var(--primary-color, #00ffcc);
        pointer-events: none;
    }

    .key-hint::before {
        top: -4px;
        left: -4px;
        border-right: none;
        border-bottom: none;
    }

    .key-hint::after {
        bottom: -4px;
        right: -4px;
        border-left: none;
        border-top: none;
    }

    .black-key .key-hint {
        top: 35%;
        background: rgba(15, 0, 15, 0.98);
        border-color: var(--secondary-color, #ff00ff);
        box-shadow: 0 0 15px rgba(255, 0, 255, 0.6), inset 0 0 8px rgba(255, 0, 255, 0.3);
    }

    .black-key .key-hint::before, .black-key .key-hint::after {
        border-color: var(--secondary-color, #ff00ff);
    }

    :host(.show-hints) .key-hint {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.1);
    }

    .oct-btn .key-hint {
        top: 50%;
        left: 50%;
        font-size: 0.75rem;
        background: rgba(0,0,0,0.9);
        border-color: #fff;
        box-shadow: 0 0 10px rgba(255,255,255,0.3);
        padding: 2px 5px;
        min-width: 0.8rem;
    }
    
    .oct-btn .key-hint::before, .oct-btn .key-hint::after {
        border-color: #fff;
        width: 4px;
        height: 4px;
    }

</style>
<div class="header" id="header">
    <div class="title-group">
        <span class="title">KEYBOARD</span>
        <button class="range-toggle" id="range-toggle" title="Toggle Size">3 OCT</button>
        <div class="controls">
            <button class="oct-btn" id="oct-down" title="Octave Down">-</button>
            <span class="oct-display" id="oct-display">C3-B5</span>
            <button class="oct-btn" id="oct-up" title="Octave Up">+</button>
        </div>
        <div class="vel-control">
            <span class="vel-label">VEL</span>
            <input type="range" class="vel-slider" id="vel-slider" min="0" max="1" step="0.01" value="0.8">
        </div>
    </div>
    <button class="fold-btn" id="fold-btn">
        <svg viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    </button>
</div>
<div class="keys-container" id="keys">
    <!-- Generated Keys will go here -->
</div>
`;

export class VirtualKeyboard extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        
        this.header = this.shadowRoot.getElementById('header');
        this.keysContainer = this.shadowRoot.getElementById('keys');
        this.foldBtn = this.shadowRoot.getElementById('fold-btn');
        this.octDownBtn = this.shadowRoot.getElementById('oct-down');
        this.octUpBtn = this.shadowRoot.getElementById('oct-up');
        this.octDisplay = this.shadowRoot.getElementById('oct-display');
        this.velSlider = this.shadowRoot.getElementById('vel-slider');
        this.rangeToggle = this.shadowRoot.getElementById('range-toggle');
        
        // Key Mapping for Hints (Matches KeyboardManager)
        this.qwertyMapping = {
            0: 'A', 1: 'W', 2: 'S', 3: 'E', 4: 'D', 5: 'F', 6: 'T', 7: 'G', 8: 'Y', 9: 'H', 10: 'U', 11: 'J',
            12: 'K', 13: 'O', 14: 'L', 15: 'P', 16: ';', 17: "'"
        };

        // State
        this.isDragging = false;
        this.dragOffset = { x: 0, y: 0 };
        this.collapsed = false;
        
        // Keyboard Configuration
        this.baseOctave = 3; // Starting octave
        this.numOctaves = 3; // Number of octaves to display
        this.velocity = 0.8;
        
        // Bindings
        this.foldBtn.addEventListener('click', (e) => {
            e.stopPropagation(); 
            this.toggleFold();
        });

        this.rangeToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleRange();
        });

        this.octDownBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.shiftOctave(-1);
        });

        this.octUpBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.shiftOctave(1);
        });


        this.velSlider.addEventListener('input', (e) => {
            e.stopPropagation(); // prevent drag
            this.velocity = parseFloat(e.target.value);
        });
        
        this.velSlider.addEventListener('mousedown', (e) => e.stopPropagation()); // prevent drag start
        this.velSlider.addEventListener('touchstart', (e) => e.stopPropagation(), {passive: true});

        this.header.addEventListener('mousedown', (e) => this.startDrag(e));
        this.header.addEventListener('touchstart', (e) => this.startDrag(e), {passive: false});

        window.addEventListener('mousemove', (e) => this.drag(e));
        window.addEventListener('touchmove', (e) => this.drag(e), {passive: false});
        
        window.addEventListener('mouseup', () => this.stopDrag());
        window.addEventListener('touchend', () => this.stopDrag());
        
        // Initial Render
        this.renderKeys();
    }
    
    toggleRange() {
        if (this.numOctaves === 3) {
            this.numOctaves = 2;
            this.rangeToggle.textContent = "2 OCT";
        } else {
            this.numOctaves = 3;
            this.rangeToggle.textContent = "3 OCT";
        }
        this.renderKeys();
    }

    getNoteFrequency(noteName) {
        // Parse note name (e.g., "C#4", "A3")
        const match = noteName.match(/([A-G]#?)(\d+)/);
        if (!match) return 0;
        
        const note = match[1];
        const octave = parseInt(match[2]);
        
        const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
        const semitoneIndex = notes.indexOf(note);
        
        // MIDI Note Number: C-1 = 0, C4 = 60, A4 = 69
        // Formula: NoteNum = (Octave + 1) * 12 + SemitoneIndex
        const midiNote = (octave + 1) * 12 + semitoneIndex;
        
        // Frequency Formula: f = 440 * 2^((d - 69)/12)
        return 440 * Math.pow(2, (midiNote - 69) / 12);
    }

    shiftOctave(delta) {
        const newOctave = this.baseOctave + delta;
        if (newOctave < 0 || newOctave > 7) return; // Limits
        
        this.baseOctave = newOctave;
        this.renderKeys();
        
        // Provide haptic/visual feedback if possible?
    }

    setBaseOctave(octave) {
        if (octave < 0 || octave > 7) return;
        this.baseOctave = octave;
        this.renderKeys();
    }

    renderKeys() {
        this.keysContainer.innerHTML = '';
        const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
        
        for (let i = 0; i < this.numOctaves; i++) {
            const currentOctave = this.baseOctave + i;
            const octaveDiv = document.createElement('div');
            octaveDiv.className = 'keyboard-octave';
            
            // White Keys
            const whiteNotes = [
                { note: 'C', offset: 0 },
                { note: 'D', offset: 2 },
                { note: 'E', offset: 4 },
                { note: 'F', offset: 5 },
                { note: 'G', offset: 7 },
                { note: 'A', offset: 9 },
                { note: 'B', offset: 11 }
            ];
            whiteNotes.forEach(wn => {
                const key = document.createElement('div');
                key.className = 'white-key';
                key.dataset.note = `${wn.note}${currentOctave}`;
                
                // Add label for C keys
                if (wn.note === 'C') {
                    const label = document.createElement('div');
                    label.className = 'note-label';
                    label.textContent = `C${currentOctave}`;
                    key.appendChild(label);
                }

                // Add QWERTY hint if in first octave
                const totalOffset = i * 12 + wn.offset;
                if (this.qwertyMapping[totalOffset]) {
                    const hint = document.createElement('div');
                    hint.className = 'key-hint';
                    hint.textContent = this.qwertyMapping[totalOffset];
                    key.appendChild(hint);
                }
                
                octaveDiv.appendChild(key);
            });
            
            // Black Keys
            const blackNotes = [
                { note: 'C#', pos: 'bk-1', offset: 1 },
                { note: 'D#', pos: 'bk-2', offset: 3 },
                { note: 'F#', pos: 'bk-3', offset: 6 },
                { note: 'G#', pos: 'bk-4', offset: 8 },
                { note: 'A#', pos: 'bk-5', offset: 10 }
            ];
            
            blackNotes.forEach(bn => {
                const key = document.createElement('div');
                key.className = `black-key ${bn.pos}`;
                key.dataset.note = `${bn.note}${currentOctave}`;

                // Add QWERTY hint
                const totalOffset = i * 12 + bn.offset;
                if (this.qwertyMapping[totalOffset]) {
                    const hint = document.createElement('div');
                    hint.className = 'key-hint';
                    hint.textContent = this.qwertyMapping[totalOffset];
                    key.appendChild(hint);
                }

                octaveDiv.appendChild(key);
            });
            
            this.keysContainer.appendChild(octaveDiv);
        }
        
        // Add hints to octave buttons
        this.addOctaveHints();

        // Update Display Text
        const startNote = `C${this.baseOctave}`;
        const endNote = `B${this.baseOctave + this.numOctaves - 1}`;
        this.octDisplay.textContent = `${startNote}-${endNote}`;
        
        this.setupKeyEvents();
    }

    addOctaveHints() {
        // Clear existing hints in buttons
        this.octDownBtn.querySelectorAll('.key-hint').forEach(h => h.remove());
        this.octUpBtn.querySelectorAll('.key-hint').forEach(h => h.remove());

        const hintDown = document.createElement('div');
        hintDown.className = 'key-hint';
        hintDown.textContent = 'Z';
        this.octDownBtn.appendChild(hintDown);

        const hintUp = document.createElement('div');
        hintUp.className = 'key-hint';
        hintUp.textContent = 'X';
        this.octUpBtn.appendChild(hintUp);
    }

    toggleMappingHints(force) {
        const isShowing = this.shadowRoot.host.classList.contains('show-hints');
        const shouldShow = force !== undefined ? force : !isShowing;
        
        if (shouldShow) {
            this.shadowRoot.host.classList.add('show-hints');
        } else {
            this.shadowRoot.host.classList.remove('show-hints');
            if (this.hintTimeout) {
                clearTimeout(this.hintTimeout);
                this.hintTimeout = null;
            }
        }
        return shouldShow;
    }

    showMappingHints(duration = 3000) {
        this.toggleMappingHints(true);
        
        if (this.hintTimeout) clearTimeout(this.hintTimeout);
        this.hintTimeout = setTimeout(() => {
            this.toggleMappingHints(false);
        }, duration);
    }

    setupKeyEvents() {
        const keys = this.shadowRoot.querySelectorAll('.white-key, .black-key');
        
        const handleStart = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const target = e.target.closest('[data-note]');
            if (!target) return;
            
            const note = target.dataset.note;
            if (target.classList.contains('active')) return; // Already active (e.g. from slide)

            target.classList.add('active');
            
            const freq = this.getNoteFrequency(note);
            this.dispatchEvent(new CustomEvent('noteon', { 
                bubbles: true, 
                composed: true,
                detail: { note, freq, velocity: this.velocity, id: `key-${note}` } 
            }));
        };

        const handleEnd = (e) => {
            e.preventDefault();
            // Handle touch end logic carefully to avoid stuck notes
             const target = e.target.closest('[data-note]');
            if (!target) return;
            
            const note = target.dataset.note;
            target.classList.remove('active');
            
            this.dispatchEvent(new CustomEvent('noteoff', { 
                bubbles: true, 
                composed: true,
                detail: { note, id: `key-${note}` } 
            }));
        };

        const handleEnter = (e) => {
            // Support for glissando (sliding over keys)
            if (e.buttons === 1 || (e.touches && e.touches.length > 0)) {
                handleStart(e);
            }
        };
        
        const handleLeave = (e) => {
             const target = e.target.closest('[data-note]');
             if(target && target.classList.contains('active')) {
                 handleEnd(e);
             }
        }

        const handleTouchMove = (e) => {
            e.preventDefault(); // Prevent scrolling while playing
            const touch = e.changedTouches[0];
            const target = this.shadowRoot.elementFromPoint(touch.clientX, touch.clientY);
            
            if (target) {
                const key = target.closest('[data-note]');
                // If we moved to a new key
                if (key && !key.classList.contains('active')) {
                    // 1. Find and stop previously active key for this touch? 
                    // Simplified: We assume single touch glissando for now or let multi-touch work independently.
                    // But 'touchmove' fires on the *target where it started*.
                    // So we must manually trigger 'noteoff' for the old key if we left it.
                    
                    // Actually, simpler approach:
                    // Just trigger start on new key. 
                    // 'noteoff' for old key is tricky without tracking "current key under finger".
                    
                    // Let's track lastKey
                    if (this.lastKey && this.lastKey !== key) {
                        // Manually trigger end on lastKey
                        const oldNote = this.lastKey.dataset.note;
                        this.lastKey.classList.remove('active');
                        this.dispatchEvent(new CustomEvent('noteoff', { 
                            bubbles: true, 
                            composed: true,
                            detail: { note: oldNote, id: `key-${oldNote}` } 
                        }));
                    }
                    
                    // Trigger start on new key
                    const note = key.dataset.note;
                    key.classList.add('active');
                    const freq = this.getNoteFrequency(note);
                    this.dispatchEvent(new CustomEvent('noteon', { 
                        bubbles: true, 
                        composed: true,
                        detail: { note, freq, velocity: this.velocity, id: `key-${note}` } 
                    }));
                    
                    this.lastKey = key;
                } else if (!key && this.lastKey) {
                    // Moved off keyboard
                    const oldNote = this.lastKey.dataset.note;
                    this.lastKey.classList.remove('active');
                    this.dispatchEvent(new CustomEvent('noteoff', { 
                        bubbles: true, 
                        composed: true,
                        detail: { note: oldNote, id: `key-${oldNote}` } 
                    }));
                    this.lastKey = null;
                }
            }
        };

        keys.forEach(k => {
            // Mouse
            k.addEventListener('mousedown', handleStart);
            k.addEventListener('mouseup', handleEnd);
            k.addEventListener('mouseleave', handleLeave);
            k.addEventListener('mouseenter', handleEnter);
            
            // Touch
            k.addEventListener('touchstart', (e) => {
                handleStart(e);
                this.lastKey = e.target.closest('[data-note]');
            }, {passive: false});
            
            k.addEventListener('touchend', (e) => {
                handleEnd(e);
                this.lastKey = null;
            });
            
            k.addEventListener('touchmove', handleTouchMove, {passive: false});
            
            k.addEventListener('touchcancel', (e) => {
                handleEnd(e);
                this.lastKey = null;
            });
        });
    }

    toggleFold() {
        this.collapsed = !this.collapsed;
        if (this.collapsed) {
            this.classList.add('folded');
            this.style.maxHeight = '40px'; // Header height
        } else {
            this.classList.remove('folded');
            this.style.maxHeight = '210px'; // Keys + Header + Padding
        }
    }

    startDrag(e) {
        if (e.target.closest('.fold-btn') || e.target.closest('.controls')) return;
        this.isDragging = true;
        const rect = this.getBoundingClientRect();
        
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        this.dragOffset.x = clientX - rect.left;
        this.dragOffset.y = clientY - rect.top;
        this.style.cursor = 'grabbing';
    }

    setKeyActive(note, active) {
        const key = this.shadowRoot.querySelector(`[data-note="${note}"]`);
        if (key) {
            if (active) key.classList.add('active');
            else key.classList.remove('active');
        }
    }

    drag(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        
        const x = clientX - this.dragOffset.x;
        const y = clientY - this.dragOffset.y;
        
        this.style.transform = 'none';
        this.style.left = `${x}px`;
        this.style.top = `${y}px`;
        this.style.bottom = 'auto';
    }

    stopDrag() {
        this.isDragging = false;
        this.style.cursor = 'default';
    }
}

customElements.define('virtual-keyboard', VirtualKeyboard);